import { LikedHeart, UnlikedHeart } from "@/Components/icons/Heard";
import { TickSvg } from "@/Pages/Dashboard/Seller/svg/Svg";
import useCartStore from "@/Store/cartStore";
import { Rating } from "@mui/material";
import { Plus } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const ProductCardUpdated = ({ img, title, price, averageRating, totalReviews, sold, onclick, liked = false,
    onToggleWishlist, product
}) => {
    const { t } = useTranslation()
    const addToCart = useCartStore((state) => state.addToCart);
    const [added, setAdded] = useState(false)
    const handleAddedClick = () => {
        addToCart(product);
        setAdded(true);
        setTimeout(() => {
            setAdded(false);
        }, 1000);
        // console.log(product)
    }; return (
        <div
            onClick={onclick}
            className={`flex w-full min-w-full  flex-col gap-[16px] items-start overflow-hidden cursor-pointer`}
        >
            <div className="bg-[#f3f3f4] relative w-full">
                <img
                    src={img}
                    loading="lazy"
                    alt="img"
                    className="w-full h-[248px] object-cover"
                />

                <div
                    onClick={(e) => {
                        e.stopPropagation();
                        onToggleWishlist();
                    }}
                    className="absolute bg-white top-3 right-3 w-[38px] h-[38px] flex items-center justify-center shrink-0 rounded-full shadow-xl drop-shadow-2xl ">
                    {liked ? <LikedHeart /> : <UnlikedHeart />}
                </div>
            </div>

            <div className="flex flex-col items-start gap-[8px] w-full ">
                <h3 className="productUpdatedHeading ">
                    {title}
                </h3>

                <div className="flex items-center gap-[4px] ">
                    <div className="flex items-center gap-[2px]">
                        <div className="flex items-center gap-2">
                            <Rating
                                value={averageRating || 0}
                                precision={0.5}
                                readOnly
                            />

                            <span className="text-sm font-medium">
                                {(averageRating || 0).toFixed(1)} 
                            </span>

                            <span className="text-gray-500 text-sm">
                                ({totalReviews})
                            </span>
                        </div>
                    </div>



                    <span className="font-medium text-[14px] text-[#555463] " >
                        ({sold} {t("sold")})
                    </span>

                </div>

                <div className="w-full flex items-center flex-row justify-between">
                    <p className="text-[16px] font-inter leading-[21px] font-[600]">{price}</p>
                    <p onClick={(e) => {
                        e.stopPropagation();
                        handleAddedClick()
                    }}
                        className={`border flex items-center rounded-full font-[600] p-1 ${added ? "bg-green-600" : " bg-transparent"}`}>{added ? <TickSvg /> : <Plus />}</p>
                </div>
            </div>
        </div>

    );
};

export default ProductCardUpdated;
